<template>
    <div id="index" class="container mx-auto px-4 pt-20 md:pt-24">
        <div id='block-search' v-if="$root.hotelCode == 'miracleon'">
            <div id='tl-search-form' class='tl-container'>
                <a href='https://www.travelline.ru/products/tl-hotel/' target='_blank'></a>
            </div>
        </div>

        <div>
            <TopBanner></TopBanner>

            <div class="text-center" v-if="$root.hotelCode == 'radissonslavyanskaya'">
                <div class="mb-2 text-sm">
                    <span class="text-black" v-if="$root.currentLanguage == 'ru'">Для бронирования гостиничных номеров Вы можете выбрать удобный для Вас способ:</span>
                    <span class="text-black" v-else-if="$root.currentLanguage == 'cn'">如需预订酒店房间，您可以选择您方便的方式：</span>
                    <span class="text-black" v-else>To make a reservation please use one of the following options at your convenience:</span>
                </div>

                <a class="block border border-[#193a65] rounded-lg mb-4 p-1 text-sm"
                   href="https://www.radissonhotels.com/ru-ru/hotels/radisson-moscow-slavyanskaya">
                    <span class="text-[#193a65]" v-if="$root.currentLanguage == 'ru'">На официальном сайте гостиницы <br/>
                        <strong class="text-[#193a65]">ЗАБРОНИРОВАТЬ</strong>
                    </span>
                    <span class="text-[#193a65]" v-else-if="$root.currentLanguage == 'cn'">在酒店的官方网站上 <br/>
                        <strong class="text-[#193a65]">预定</strong>
                    </span>
                    <span class="text-[#193a65]" v-else>Via official hotel website   <br/>
                        <strong class="text-[#193a65] text">BOOK</strong>
                    </span>
                </a>
                <a class="block border border-[#193a65] rounded-lg mb-4 p-1 text-sm" href="mailto:reserv@rdmos.ru">
                    <span class="text-[#193a65]" v-if="$root.currentLanguage == 'ru'">По электронной почте службы бронирования <br/>
                        <strong class="text-[#193a65] text">НАПИСАТЬ</strong>
                    </span>
                    <span class="text-[#193a65]" v-else-if="$root.currentLanguage == 'cn'">通过电子邮件发送至预订服务中心 <br/>
                        <strong class="text-[#193a65] text">写信</strong>
                    </span>
                    <span class="text-[#193a65]" v-else>Via e-mail of reservations department  <br/>
                        <strong class="text-[#193a65] text">WRITE</strong>
                    </span>
                </a>
                <a class="block border border-[#193a65] rounded-lg mb-4 p-1 text-sm" href="tel:+74959418021">
                    <span class="text-[#193a65]" v-if="$root.currentLanguage == 'ru'">По телефону службы бронирования <br/>
                        <strong class="text-[#193a65]">ПОЗВОНИТЬ</strong>
                    </span>
                    <span class="text-[#193a65]" v-else-if="$root.currentLanguage == 'cn'">致电给预定服务中心 <br/>
                        <strong class="text-[#193a65]">致电</strong>
                    </span>
                    <span class="text-[#193a65]" v-else>Via telephone of reservations department  <br/>
                        <strong class="text-[#193a65] text">CALL</strong>
                    </span>
                </a>
            </div>
            <div class="text-center" v-if="$root.hotelCode == 'demidkovo'">
                <div class="mb-2 text-sm">
                    <div class="text-black">
                        Уважаемые гости! Сервис находится в режиме тестирования. Если Вам не перезвонили в течение 30
                        минут
                        после оформления заказа, просьба связаться по номеру:
                        <a class="text-blue-500 text-sm" href="tel:+79128827755">
                            +7-912-882-77-55
                        </a>
                        для уточнения. Благодарим за понимание.
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <div>
                    <app-sections></app-sections>
                </div>
                <div class="py-2">
                    <div class="text-center" v-if="$root.hotelCode == 'jaodacha'">
                        <a class="block border border-yellow-900 bg-yellow-900 rounded-lg mb-4 p-1 text-sm"
                           href="tel:+79300765751">
                        <span class="text-white text-lg font-medium">
                            Отдел бронирования
                        </span><br/>
                            <span class="text-white text-md">
                            +7 (930) 076 57 51
                        </span>
                        </a>
                        <a class="block border border-yellow-900 bg-yellow-900 rounded-lg mb-4 p-1 text-sm"
                           href="tel:+79201296511">
                        <span class="text-white text-lg font-medium">
                            Ресторан 
                        </span><br/>
                            <span class="text-white text-md">
                            +7 (920) 129 65 11
                        </span>
                        </a>
                    </div>
                    <app-social></app-social>
                </div>
                <div class="slide-banner pl-1 pr-1 pb-3 rounded p-3">
                    <app-banner></app-banner>
                </div>
                <article-extra-popup></article-extra-popup>
            </div>
        </div>
    </div>
</template>

<script>
import TopBanner from "../../components/article/TopBanner";
import AppSections from "../../components/article/AppSections.vue";
import AppSocial from "../../components/layout/AppSocial";
import AppBanner from "../../components/article/AppBanner";
import ArticleExtraPopup from './../Product/ArticleExtraPopup';
import AppHeader from "@/components/layout/header/AppHeader.vue";
import selectLanguage from "@/components/layout/header/ArticleSelectLang.vue";
import AppFooter from "@/components/layout/AppFooter.vue";


export default {
    name: "HomeNew",

    components: {
        AppFooter,
        selectLanguage, AppHeader, TopBanner, AppSections, AppBanner, AppSocial, ArticleExtraPopup
    },

    mounted() {
        window.scrollTo(0, 0);

        /* remove div.overlist from dom on Back Button if exists */
        if (document.getElementsByClassName('overlist')[0] !== undefined) {
            let elem = document.getElementsByClassName('overlist')[0];
            elem.parentNode.removeChild(elem);
        }
    },
}
</script>